import {Injectable} from '@angular/core';
import {CdMdsAnswer} from '../../interfaces/care/cd-rai/cd-mds-answer';
import {SecureTable} from '../secure.table';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {CdMdsAnswerFactory} from '../../factories/care/cd-rai/cd-mds-answer-factory';
import {db} from '../db.service';

@Injectable({
  providedIn: 'root'
})
export class CdMdsAnswersTable extends SecureTable<CdMdsAnswer> {

  /**
   *
   */
  constructor() {
    super(db.cdMdsAnswers);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'many',
      dependencies: [],
      adapter: new DefaultAdapter<CdMdsAnswer>({
        api: ['care', 'c-rais', '{foreignKey}', 'c-mds-answers'],
        foreignKey: 'cdRaiUuid',
        fromObject: CdMdsAnswerFactory.fromObject,
        toRemote: CdMdsAnswerFactory.toRemote,
        fromArray: CdMdsAnswerFactory.fromArray,
        toArray: CdMdsAnswerFactory.toArray
      })
    };
  }

  /**
   *
   * @param uuid
   */
  public async getByCdRaiUuid(uuid: string): Promise<CdMdsAnswer[]> {
    return this.table.where('cdRaiUuid').equals(uuid).toArray();
  }

  /**
   *
   * @param uuids
   */
  public async getByCdRaiUuids(uuids: string[]): Promise<CdMdsAnswer[]> {
    return this.table.where('cdRaiUuid').anyOf(uuids).toArray();
  }

  /**
   *
   * @param cdRaiUuids
   */
  public async isSyncedByCdRaiUuids(cdRaiUuids: string[]): Promise<boolean> {
    const cdMdsAnswers = await this.getByCdRaiUuids(cdRaiUuids);
    return this.isSyncedByUuids(cdMdsAnswers.map(_cdMdsAnswer => _cdMdsAnswer.uuid));
  }

}
